import { z } from "zod";
import { resourceReferenceSchema, resourceReferencesQuerySchema } from "./resource-references.js";
const id = z.string().trim().min(1).max(200);
const lease = {
    runId: id, tenantSlug: id, workerId: id,
    attemptNumber: z.number().int().positive(),
};
export const workerWorkspaceResourceRequestSchema = z.discriminatedUnion("operation", [
    z.object({ ...lease, operation: z.literal("search"), input: resourceReferencesQuerySchema.extend({
            type: z.enum(["session", "artifact"]),
        }) }).strict(),
    z.object({ ...lease, operation: z.literal("session.read"), input: z.object({
            sessionId: id, cursor: z.string().min(1).max(2048).optional(),
            limit: z.number().int().min(1).max(50).default(20),
        }).strict() }).strict(),
    z.object({ ...lease, operation: z.literal("artifact.read"), input: z.object({
            artifactId: id, versionId: id.optional(),
        }).strict() }).strict(),
]);
const reference = resourceReferenceSchema.extend({ type: z.enum(["session", "artifact"]), url: z.string().url() });
export const workerWorkspaceResourceResponseSchema = z.discriminatedUnion("operation", [
    z.object({ operation: z.literal("search"), resources: z.array(reference), nextCursor: z.string().nullable() }).strict(),
    z.object({ operation: z.literal("session.read"),
        session: z.object({ id, title: z.string(), url: z.string().url() }),
        messages: z.array(z.object({ id, role: z.enum(["user", "assistant"]), text: z.string(),
            createdAt: z.number(), continued: z.boolean() })),
        artifacts: z.array(reference), artifactsHasMore: z.boolean(), nextCursor: z.string().nullable(),
    }).strict(),
    z.object({ operation: z.literal("artifact.read"), artifact: z.object({
            id, versionId: id, version: z.number().int().positive(), kind: z.enum(["markdown", "csv"]),
            title: z.string(), content: z.string(),
        }) }).strict(),
]);
